/* aw-kaart.js — de productkaart zoals het andere thema hem toont.
 *
 * Horizon zet een vaste tekst "Sale" op de badge; de bron rekent het
 * kortingspercentage uit en schrijft "SAVE 49%". Dat kan niet in de opmaak van
 * het thema (die mogen we niet aanraken) en ook niet in CSS, dus rekenen we het
 * hier uit de prijzen die al op de kaart staan.
 */
(() => {
  const getal = (tekst) => {
    if (!tekst) return NaN;
    // laatste getal in de tekst, punt of komma als decimaalteken
    const m = tekst.replace(/\s/g, '').match(/([\d.,]+)(?!.*[\d.,])/);
    if (!m) return NaN;
    let s = m[1];
    // 1.234,56 -> 1234.56 ; 1,234.56 -> 1234.56
    if (/,\d{2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    return parseFloat(s);
  };

  function zetBadge(kaart) {
    const badge = kaart.querySelector('.product-badges__badge');
    if (!badge || badge.dataset.awKorting) return;
    const nu = kaart.querySelector('.price:not(.compare-at-price), [class*="on-sale"]');
    const was = kaart.querySelector('.compare-at-price, [class*="compare"], s, del');
    const a = getal(nu && nu.textContent);
    const b = getal(was && was.textContent);
    if (!isFinite(a) || !isFinite(b) || b <= a) return;
    const pct = Math.round((1 - a / b) * 100);
    if (!isFinite(pct) || pct <= 0) return;
    badge.dataset.awKorting = '1';
    badge.textContent = 'Save ' + pct + '%';
  }

  function scan(wortel) {
    (wortel || document)
      .querySelectorAll('product-card, .product-card, .resource-list__item')
      .forEach(zetBadge);
  }

  const start = () => requestAnimationFrame(() => setTimeout(scan, 60));
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
  document.addEventListener('DOMContentLoaded', start);

  // hzo-speed 16 sep 2026: niet per toegevoegd knooppunt scannen (Horizons hydratie voegt er duizenden toe en dit
  // script kostte daardoor 200-360 ms op elke pagina), maar één keer per frame over het hele document; zetBadge slaat
  // kaarten die al een badge hebben over via het data-attribuut, dus dat is goedkoop.
  let gepland = false;
  new MutationObserver(() => {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(() => { gepland = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
